import React, { createContext, useContext, useState } from "react";
import Utils from "../utils";

const WorkspaceExperienceContext = createContext();

export const useWorkspaceExperience = () => {
  const context = useContext(WorkspaceExperienceContext);
  if (!context) {
    throw new Error("useWorkspaceExperience must be used within a WorkspaceExperienceProvider");
  }
  return context;
};

export const WorkspaceExperienceProvider = ({ children }) => {
  const [workspaceExperienceEnabled, setWorkspaceExperienceEnabledState] = useState(() =>
    Utils.isWorkspaceExperienceEnabled()
  );

  // Persists via Utils (the same localStorage key it reads for non-component callers like
  // user.actions.js and oktaAuthWrapper.jsx) so every reader — reactive or not — stays in
  // sync off a single source of truth.
  const setWorkspaceExperienceEnabled = (enabled) => {
    Utils.setWorkspaceExperienceEnabled(enabled);
    setWorkspaceExperienceEnabledState(enabled);
  };

  const toggleWorkspaceExperience = () => {
    setWorkspaceExperienceEnabled(!workspaceExperienceEnabled);
  };

  return (
    <WorkspaceExperienceContext.Provider
      value={{
        workspaceExperienceEnabled,
        setWorkspaceExperienceEnabled,
        toggleWorkspaceExperience,
      }}
    >
      {children}
    </WorkspaceExperienceContext.Provider>
  );
};
